import { useEffect, useState } from 'react'
import { addDays, compareAsc, differenceInDays } from 'date-fns'

function useBookingDates(initialDateFrom?: Date, initialDateTo?: Date) {
  const [dateFrom, setDateFrom] = useState<Date>()
  const [dateTo, setDateTo] = useState<Date>()

  useEffect(() => {
    if (initialDateFrom) setDateFrom(initialDateFrom)
  }, [initialDateFrom])

  useEffect(() => {
    if (initialDateTo) setDateTo(initialDateTo)
  }, [initialDateTo])

  const changeFrom = (date_value?: Date) => {
    const old_date_from = dateFrom
    setDateFrom(date_value)

    if (date_value && dateTo && compareAsc(date_value, dateTo) >= 0) {
      const numDays = old_date_from ? differenceInDays(dateTo, old_date_from) : 1
      setDateTo(addDays(date_value, numDays))
    }
  }

  const changeTo = (date_value?: Date) => {
    setDateTo(date_value)
  }

  return { dateFrom, changeFrom, setDateFrom, dateTo, changeTo, setDateTo }
}

export default useBookingDates
